import { Injectable } from '@angular/core';
import { VitalParams } from '../routes/screen/nightingale-ro/charts/vital-params';

@Injectable({
    providedIn: 'root'
})
export class SignalElementsService {

    static readonly listComponents = {
        sensors: [
            { name: 'e0', descr: 'ЕКГ сензор I', ch: [1, 2, 3] },
            { name: 'e1', descr: 'ЕКГ сензор II', ch: [2, 3] },
            { name: 'III', descr: 'ЕКГ сензор III', ch: [2, 3] },
            { name: 'aVR', descr: 'ЕКГ сензор aVR', ch: [2, 3] },
            { name: 'aVL', descr: 'ЕКГ сензор aVL', ch: [2, 3] },
            { name: 'aVF', descr: 'ЕКГ сензор aVF', ch: [2, 3] },
            { name: 'Inferior', descr: 'ЕКГ сензор Inferior', ch: [2] },
            { name: 'Anterior', descr: 'ЕКГ сензор Anterior', ch: [2] },

            { name: 'e7', descr: 'ЕКГ сензор V1', ch: [3] },
            { name: 'e2', descr: 'ЕКГ сензор V2', ch: [3] },
            { name: 'e3', descr: 'ЕКГ сензор V3', ch: [3] },
            { name: 'e4', descr: 'ЕКГ сензор V4', ch: [3] },
            { name: 'e5', descr: 'ЕКГ сензор V5', ch: [3] },
            { name: 'e6', descr: 'ЕКГ сензор V6', ch: [3] },

            { name: 'li', descr: 'PPG', ch: [1, 2, 3] },
            { name: 'rw', descr: 'Phonocardiography', ch: [1, 2, 3] }
        ],
        vitalParams: [
            { name: 'hr', descr: 'Pulse', dp: 0 },
            { name: 'hs', descr: 'Pulse SPO', dp: 0 },
            { name: 'tp', descr: 'Temperature', dp: 1 },
            { name: 'br', descr: 'Respiration', dp: 0 },
            { name: 'pl', descr: 'Diastolic blood pressure', dp: 0 },
            { name: 'ph', descr: 'Systolic blood pressure', dp: 0 },
            { name: 'o2', descr: 'Sp02 scale', dp: 0 },
            { name: 'mp', descr: 'Mean blood pressure', dp: 0 },
            { name: 'pp', descr: 'Pulse pressure', dp: 0 },
            { name: 'esCO', descr: 'es CO l/min', dp: 1 },
            { name: 'QT', descr: 'QT interval', dp: 0 },
            { name: 'SDNN', descr: 'SDNN', dp: 0 },
            { name: 'RMSSD', descr: 'RMSSD', dp: 0 },
            { name: 'PNN50', descr: 'PNN(50)', dp: 0 },
            { name: 'StressIdx', descr: 'SI(stress index)', dp: 0 },
            { name: 'CentrIdx', descr: 'ANS(cent.index)', dp: 1 },
            { name: 'ShockIdx', descr: 'SI(shock index)', dp: 0 },
            { name: 'pd', descr: 'Pulse deflict', dp: 0 },
            { name: 'news_tot', descr: 'News', dp: 0 },
            { name: 'GDS', descr: 'General deterioration score', dp: 0 },
            { name: VitalParams.GA_RV, descr: 'HRV', dp: 0 },
            { name: VitalParams.GA_SC, descr: 'Steps (per 20 sec window)', dp: 0 },
            { name: VitalParams.GA_ST, descr: 'Steps Total', dp: 0 },
            { name: VitalParams.GA_SS, descr: 'Stress (per 20 sec window)', dp: 0 },
            { name: VitalParams.GA_ZC, descr: 'Zero crossing (per 20 sec window)', dp: 0 },
            { name: VitalParams.GA_ZE, descr: 'Energy', dp: 0 },
            { name: VitalParams.AC, descr: 'Activity', dp: 0 },
        ],
        vitalParamsVar: ['HT', 'GT', '30T'],
        vitalParamsVarVar: ['c', 's'],
    }

    static readonly trendColors = {
        "0": "green",
        "1": "yellow",
        "2": "orange",
        "3": "red",
    }
    static readonly trendHexColors = {
        "0": "#31926f",
        "1": "#fdff08",
        "2": "#fe8a15",
        "3": "#fe0303",
    }

    static readonly opacityArr = {
        "-1": 1,
        "0": 1,
        "1": 1,
        "2": 0.67,
        "3": 0.33
    }

    static readonly trendClass = {
        "1": "up",
        "0": "stable",
        "-1": "down",
    }

    static readonly trendContainerClass = {
        "1": "increasing",
        "0": "stable",
        "-1": "decreasing",
    }

    static readonly trendText = {
        "1": "Increasing",
        "0": "Stable",
        "-1": "Decreasing"
    }

    static readonly riskText = {
        0: 'LOW RISK',
        1: 'MEDIUM RISK',
        2: 'HIGH RISK',
        3: 'CRITICAL RISK'
    }

    static findDescr(name: string, type: string) {
        if (name == 'pl/ph' && type == 'vitalParams') {
            return 'Blood Pressure';
        }
        return SignalElementsService.listComponents[type].find(el => el.name == name).descr;
    }

    static findSensorsByChannel(channel: number) {
        return SignalElementsService.listComponents.sensors.filter(el => el.ch.includes(Number(channel)));
    }

    static calcDeteriorationRiskLevel(risk: any) {
        if (risk > 79) {
            return 3;
        } else if (risk > 64) {
            return 2
        } else if (risk > 49) {
            return 1;
        } else {
            return 0;
        }
    }

    static calcNewsLevel( news: any) {
        if (news > 7) {
           return 3;
        } else if (news > 5) {
            return 2;
        } else if (news > 3) {
            return 1;
        } else {
            return 0;
        }
    }

    static calcCpcEwsLevel( news: any) {
        if (news >= 6) {
           return 3;
        } else if (news >= 3) {
            return 2;
        } else {
            return 0;
        }
    }

}